import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {

  baseUrl: string = 'https://4ed6-102-89-47-26.eu.ngrok.io'

  constructor(private http: HttpClient) { }

  getEcosystem(page: number, start: number, operator: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/report_ecosystem`, { page, start, operator })
  }
  getSheet(ecosystemId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/report_sheets`, { id: ecosystemId })
  }
  getSheetData(sheetId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/report_sheet_data`, { id: sheetId })
  }

  EditData(sheetId: number, data:any, dataId:any): Observable<any> {

  //   let value = [];
  //   let keys = []
  //   for (var key in data) {

  //     if (data.hasOwnProperty(key)) {

  //         console.log('key', key);
  //         console.log('value', data[key]);
  //         keys.push(dataId ?key+"=?" :key); 
  //         value.push(data[key])
  //     }
  // }
  //   console.log("kyes",keys);
  //   console.log("values",value);

  console.log({sheetId: sheetId, data:data, dataId:dataId });
  
    
    return this.http.post(`${this.baseUrl}/update_or_create_data`, { sheetId: sheetId, data:data, dataId:dataId })
    
  }
  
}
